export const removeFromSet = <T>(set: Set<T>, value: T): Set<T> => {
  const next = new Set(set);
  next.delete(value);
  return next;
};

export const addToSet = <T>(set: Set<T>, value: T): Set<T> => {
  return new Set(set).add(value);
};

export const toggleInSet = <T>(set: Set<T>, value: T): Set<T> => {
  const next = new Set(set);
  next.has(value) ? next.delete(value) : next.add(value);
  return next;
};

export const plural = (count: number, noun: string, suffix = "s") =>
  `${count} ${noun}${count !== 1 ? suffix : ""}`;
